import { render, staticRenderFns } from "./MaterialAttributeList.vue?vue&type=template&id=3673f785&scoped=true"
import script from "./MaterialAttributeList.vue?vue&type=script&lang=js"
export * from "./MaterialAttributeList.vue?vue&type=script&lang=js"
import style0 from "./MaterialAttributeList.vue?vue&type=style&index=0&id=3673f785&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673f785",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3673f785')) {
      api.createRecord('3673f785', component.options)
    } else {
      api.reload('3673f785', component.options)
    }
    module.hot.accept("./MaterialAttributeList.vue?vue&type=template&id=3673f785&scoped=true", function () {
      api.rerender('3673f785', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/MaterialAttributeList.vue"
export default component.exports